import type { ReactNode } from "react";
import { useCurrentUser } from "@/lib/auth";
import { userCanManageZeiterfassungSettings } from "@/lib/zeiterfassungPermissions";
import { Alert } from "@/components/ui/Alert";
import { Spinner } from "@/components/ui/Spinner";

export function RequireBueroOrAdmin({ children }: { children: ReactNode }) {
  const { user, loading, error } = useCurrentUser();

  if (loading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-label-secondary">
        <div className="flex items-center gap-2 text-sm">
          <Spinner />
          <span>Sitzung wird geprüft …</span>
        </div>
      </div>
    );
  }

  if (error || !user) {
    return (
      <div className="mx-auto max-w-md py-10">
        <Alert variant="error" title="Sitzung konnte nicht geladen werden">
          {error || "Bitte erneut anmelden."}
        </Alert>
      </div>
    );
  }

  if (!userCanManageZeiterfassungSettings(user)) {
    return (
      <div className="mx-auto max-w-md py-10">
        <Alert variant="error" title="Keine Berechtigung">
          Diese Seite ist für Büro-Mitarbeiter und Admins.
        </Alert>
      </div>
    );
  }

  return <>{children}</>;
}
